export default __webpack_public_path__ + "static/media/MySQL-WindowsTaskScheduler-TriggerDailyTimeSetting03.bf43e81f.png";